import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { ResourceVm } from 'qp-ui-interface';
import { Observable, from } from 'rxjs';
import { DataService } from '../../data.service';
import { AdaptorData } from '../../storefront/AdaptorData';
import { TabService } from '../services/tabs/tab.service';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { KEYS } from '../utils/constants/storage.constants';
import { ContentEntitlementService } from '../services/evergent/entitlement/content-entitlement.service';
import { MetaDataService } from '../services/meta-data.service';

@Injectable()
export class DetailsPageResolver implements Resolve<ResourceVm> {
  constructor(
    private readonly tabService: TabService,
    private readonly dataService: DataService,
    private readonly metaDataService: MetaDataService,
    private readonly router: Router,
    private readonly localStorage: LocalStorageService,
    private readonly contentEntlmtService: ContentEntitlementService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ResourceVm> | null {
    // Only fetch if coming from deeplink (no existing data)
    if (this.dataService.isFromDeeplink || !this.dataService.selectedCardData) {
      const detailData = this.fetchDetailsData(
        route.params.contentType,
        route.params.id
      );
      return from(detailData);
    }

    // Skip resolver for normal navigation (data already exists)
    return null;
  }

  private async fetchDetailsData(
    contentType: any,
    id: any
  ): Promise<ResourceVm> {
    const adaptorData: AdaptorData = {
      resourceType: contentType,
      resourceId: id,
      storefrontId: this.localStorage.getItem(KEYS.STOREFRONT_ID),
      tabId: this.dataService.activeTab,
      tabName: this.tabService.getCurrentTab()?.name,
    };

    const resourceVm = await this.metaDataService
      .fetchResourceVM(adaptorData)
      .catch(() => {
        this.dataService.isFromDeeplink = false;
        this.dataService.setPendingDeeplinkUrl = null;
        this.router.navigate([this.dataService.homeTab || '/']);
        return Promise.reject();
      });
    if (!resourceVm) {
      this.router.navigate([this.dataService.homeTab]);
      return Promise.reject();
    }

    resourceVm.isPurchased =
      this.contentEntlmtService.isContentPurchased(resourceVm);

    return Promise.resolve(resourceVm);
  }
}
